/*
* Navigation / site header scripts
*/

let isMenuShown = false;
const headerElement = document.querySelector(".c-header");
const headerFocusableWrappers = headerElement.querySelectorAll(".c-header__row--mobile, .c-header__row--bottom");
const headerToggleElement = headerElement.querySelector(".c-header__toggle");
const headerToggleTextClose = headerToggleElement.querySelector(".c-header__toggle-text--closed");
const headerToggleTextOpen = headerToggleElement.querySelector(".c-header__toggle-text--open");

// Breakpoint definitions aligned with the SCSS setup
const BP_MOBILE = 480;
const BP_TABLET = 768;
const BP_DESKTOP = 1024;
const BP_WIDE = 1200;

// Global key variables
const KEY_ESC = ["Escape", "Esc"]; // Esc for IE/Edge
const KEY_ENTER = "Enter";
const KEY_TAB = "Tab";
const KEY_SHIFT = "Shift";

const HTML_ELEMENT = document.querySelector("html");

let firstElement;
let lastElement;

(function() {
    // Toggle main menu visibility on button click
    headerToggleElement.addEventListener("click", function(e) {
        toggleMenuVisibility(!isMenuShown);
    });
}());


/*
* Update classes and attributes to match the expected menu state
* @param value boolean indicating whether the menu is opened or closed
*/
function toggleMenuVisibility(value) {
    isMenuShown = value;
    HTML_ELEMENT.classList.toggle("state--nav-open", value);
    headerToggleElement.setAttribute("aria-expanded", value);
    headerToggleTextClose.setAttribute("aria-hidden", value);
    headerToggleTextOpen.setAttribute("aria-hidden", !value);

    trapFocus(headerFocusableWrappers, value ? headerToggleElement : null);
}
    
/*
* Config for the focus trap
* @param {array} parents - an array of elements to which the focus should be constrained
* @param {HTMLElement} elementToFocus - an element to focus when the trap is activated.
* Focus trap will be removed from the parent when no elementToFocus is passed
*/
function trapFocus(parents, elementToFocus) {
    // If no elementToFocus is passed, remove all event listeners and get out of here
    if(!elementToFocus) {
        // Trap off. Remove event listeners
        window.removeEventListener("keydown", handleTrapKeydown);
        return;
    }

    let elements = [];
    // Otherwise find all focusable elements inside the parent element passed to this function
    Array.from(parents).forEach(item => {
        elements.push(...getFocusableElements(item));
    });
    
    // firstElement / lastElement are used to tell if we need to loop our focus backwards or forwards
    firstElement = elements[0];
    lastElement = elements[elements.length - 1];
    // Trap on
    elementToFocus.focus();
    window.addEventListener("keydown", handleTrapKeydown);

}

/* 
* Get focusable elements inside a wrapper
* @param {HTMLElement} element - the wrapper element to be searched through for focusable items
* @returns {array} focusable
*/
function getFocusableElements(element) {
    let focusable = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');        
    // Filter to remove elements that are visually hidden with css
    focusable = Array.from(focusable).filter(item => {
        return window.getComputedStyle(item).visibility !== "hidden";
    });
    return focusable;
}

/* 
* Keydown event handler for the focus trap
* Checking which key was pressed, handling looping, etc.
*/
function handleTrapKeydown(e) {
    const isTabPressed = (e.key === KEY_TAB);

    if (!isTabPressed) {
        return;
    }

    if (e.shiftKey) {
        if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
        }
    } else {
        if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
        }
    }
}
/*
* Set up all global event handlers here
*/
(function() {
    window.addEventListener("keyup", function(e) {
        if(KEY_ESC.includes(e.key)) {
            handleEscapeKey();
        }
    });

    window.addEventListener("resize", debounce(function(e) {
        handlePageResize();
    }, 50));

    /*
    * Function invoked when the page is resized
    */
    function handlePageResize() {
        toggleMenuVisibility(false);
    }

    /*
    * Function invoked when the escape key is pressed
    */
    function handleEscapeKey() {
        toggleMenuVisibility(false);
    }
}());

/*
 * Debounce to limit a number of times a function is called
 * @param func function to debounce
 * @param delay time to delay the function call
 * @param immediate boolean to call the function immediately
 */
function debounce(func, delay, immediate) {
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, delay);

        if (callNow) func.apply(context, args);
    };
}
